/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Power_DescInputs */

const en_ui_color_by_power_desc = /** @type {(inputs: Ui_Color_By_Power_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z1–Z7 · map + power chart`)
};

const de_ui_color_by_power_desc = /** @type {(inputs: Ui_Color_By_Power_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z1–Z7 · Karte + Leistungs-Chart`)
};

/**
* | output |
* | --- |
* | "Z1–Z7 · map + power chart" |
*
* @param {Ui_Color_By_Power_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_power_desc = /** @type {((inputs?: Ui_Color_By_Power_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Power_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_power_desc(inputs)
	return de_ui_color_by_power_desc(inputs)
});